<template>
  <div>
    <div v-for="(number, index) in phoneNumbers" :key="index" class="input-group mb-2">
      <input type="tel" class="form-control sim_number client_inputs" v-model.trim="number.sim_number"
        name="receiver_sim_number[]" required @change="handleSimNumberChange(index)" />
      <div class="input-group-append">
        <button v-if="index === 0" type="button" class="btn btn-success"
          :disabled="phoneNumbers.length >= maxPhoneNumberCount" @click="addPhoneNumber">
          <i class="fa fa-fw fa-plus"></i>
        </button>
        <button v-else type="button" class="btn btn-danger removePhoneNumberBtn" @click="removePhoneNumber(index)">
          <i class="fa fa-fw fa-minus"></i>
        </button>
      </div>
    </div>
    <div id="clientNumLoader" hidden>Loading...</div>
  </div>
</template>

<script>
export default {
  props: {
    initialSimNumbers: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      phoneNumbers: [...this.initialSimNumbers],
      maxPhoneNumberCount: 4,
      isProcessing: false,
      messageQueue: [],
      isProcessingQueue: false
    };
  },
  created() {
    this.addInitialPhoneNumberField();
  },
  watch: {
    initialSimNumbers: {
      handler(newVal) {
        // Transform the array of strings into array of objects
        this.phoneNumbers = newVal.map(sim => ({ sim_number: sim }));
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    emitPhoneNumbers() {
      const data = this.collectFormData();
      this.$emit('update:simNumbers', data); // Emit the updated phone numbers to the parent
    },
    addMessageToQueue(type, title, message) {
      this.messageQueue.push({ type, title, message });
      if (!this.isProcessingQueue) {
        this.displayMessageQueue();
      }
    },
    async displayMessageQueue() {
      if (this.messageQueue.length === 0) {
        this.isProcessingQueue = false;
        return;
      }

      this.isProcessingQueue = true;
      while (this.messageQueue.length > 0) {
        const { type, title, message } = this.messageQueue.shift();
        const confirmButtonText = type === 'warning' ? 'OK' : 'Close';

        await this.$nextTick();
        await Swal.fire({
          icon: type,
          title: title,
          html: `<div>${message}</div>`,
          confirmButtonColor: type === 'error' ? '#d33' : undefined,
          confirmButtonText
        });
      }
      this.isProcessingQueue = false;
    },
    normalizeNumber(number) {
      return number.replace(/\D/g, '');
    },
    isSimilarNumber(num1, num2) {
      const n1 = this.normalizeNumber(num1);
      const n2 = this.normalizeNumber(num2);
      return n1.includes(n2) || n2.includes(n1);
    },
    addPhoneNumber(simNumber = '') {
      if (this.phoneNumbers.length >= this.maxPhoneNumberCount) {
        this.addMessageToQueue('error', 'Cannot Add More Phone Numbers', 'You cannot add more than 4 phone numbers.');
        return;
      }
      this.phoneNumbers.push({ sim_number: simNumber });
      this.emitPhoneNumbers(); // Emit after adding a phone number
    },
    removePhoneNumber(index) {
      this.phoneNumbers.splice(index, 1);
      this.emitPhoneNumbers(); // Emit after removing a phone number
    },
    addInitialPhoneNumberField() {
      if (this.initialSimNumbers.length > 0) {
        this.phoneNumbers = this.initialSimNumbers.map(sim => ({ sim_number: sim }));
      } else {
        this.addPhoneNumber(); // Add one by default if no initial numbers
      }
    },
    collectFormData() {
      return this.phoneNumbers.map(p => p.sim_number ? p.sim_number.trim() : '');
    },
    handleSimNumberChange(index) {
      if (this.isProcessing) return;
      this.isProcessing = true;

      const simData = this.collectFormData(); // Collect all phone numbers

      console.log('Form Data Before Validation:', simData); // Check the collected data

      // Check if all phone number fields are filled
      if (simData.some(sim_number => !sim_number.trim())) {
        this.addMessageToQueue('error', 'Missing Phone Numbers', 'All phone number fields are required.');
        this.isProcessing = false;
        return;
      }

      document.getElementById("clientNumLoader").hidden = false;

      this.emitPhoneNumbers(); // Emit after removing a phone number

      // Simulate API call delay
      setTimeout(() => {
        document.getElementById("clientNumLoader").hidden = true;
        this.isProcessing = false;
      }, 1000);
    }
  }
};
</script>

<style scoped>
.input-group-append button {
  min-width: 40px;
}
</style>
